import {useState} from 'react'
import {useGetUser} from '../../store/userStore'
import {isAdministrator} from '../../helpers'
import {useCanProvisionNumbers} from '../../hooks/useNumberProvisioning'
import {NumbersPage} from '../numbers/NumbersPage'
import {TwilioBillingPage} from '../twilioBilling/TwilioBillingPage'
import {RebillingTab} from './RebillingTab'
import {UsageByNumberTab} from './UsageByNumberTab'

// Billing hub: "My Numbers" (agent self-service) and "Cost & Usage" (admin
// spend + inventory) as tabs. Tabs shown per role — agents see My Numbers,
// admins see Cost & Usage (both when applicable).
export const BillingPage = () => {
  const permissions = useGetUser((s: any) => s.user?.permissions)
  const isAdmin = isAdministrator(permissions || [])
  const {enabled: canProvision} = useCanProvisionNumbers()

  const tabs: {key: string; label: string}[] = []
  if (canProvision) tabs.push({key: 'numbers', label: 'My Numbers'})
  if (isAdmin) tabs.push({key: 'cost', label: 'Cost & Usage'})
  if (isAdmin) tabs.push({key: 'usage', label: 'Consumption by Number'})
  if (isAdmin) tabs.push({key: 'rebilling', label: 'Rebilling'})

  const [active, setActive] = useState<string>('')
  const current = active || tabs[0]?.key || ''

  return (
    <div className='mt-5'>
      {tabs.length > 1 && (
        <ul className='nav nav-tabs nav-line-tabs fs-6 mb-2'>
          {tabs.map((t) => (
            <li className='nav-item' key={t.key}>
              <a
                className={`nav-link ${current === t.key ? 'active' : ''}`}
                style={{cursor: 'pointer'}}
                onClick={() => setActive(t.key)}
              >
                {t.label}
              </a>
            </li>
          ))}
        </ul>
      )}
      {current === 'numbers' && <NumbersPage />}
      {current === 'cost' && <TwilioBillingPage />}
      {current === 'usage' && <UsageByNumberTab />}
      {current === 'rebilling' && <RebillingTab />}
    </div>
  )
}
